var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',{staticClass:"foot-mark"},[_vm._v(" "+_vm._s(_vm.$t('footer_container.mark'))+" ")]),_c('div',{staticClass:"mfs-auto"},[_c('Info')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }